// client/src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

// roles: optional array of allowed roles (e.g. ['admin', 'super_admin']).
// Omit it to just require any logged-in user.
const ProtectedRoute = ({ roles, children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;

  return children ?? <Outlet />;
};

export default ProtectedRoute;
